const saverconfig: any = {
	main_url: process.env.REACT_APP_API_SERVICE_URL || "https://api.clueso.io",
	// main_url: "http://localhost:8080",
};

export default saverconfig;

